import React, { useState, useEffect } from 'react';
import axios from 'axios';

const FileUpload = () => {
  const [file, setFile] = useState(null);

  const handleFileChange = event => {
    setFile(event.target.files[0]);
  }

  const handleSubmit = event => {
    event.preventDefault();

    axios.post(`${process.env.REACT_APP_BACKEND_API_SERVER}/upload`, file).then(response => {
        console.log(response.data);
      }).catch(error => {
        console.error(error);
      });
  }

  return (
    <form onSubmit={handleSubmit}>
      <label>
        Upload file:
        <input type="file" onChange={handleFileChange} />
      </label>
      <button type="submit">Upload</button>
    </form>
  );
}

export default FileUpload;
